// eslint-disable-next-line import/prefer-default-export
export const fetchEnv = varKey => state => state.env[varKey];
